import { render, staticRenderFns } from "./HomeworkSummaryDetails.vue?vue&type=template&id=49c2ab17&scoped=true&"
import script from "./HomeworkSummaryDetails.vue?vue&type=script&lang=js&"
export * from "./HomeworkSummaryDetails.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkSummaryDetails.vue?vue&type=style&index=0&id=49c2ab17&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c2ab17",
  null
  
)

export default component.exports